export const MOBILE_PHONE = 'mobilePhone';